import user from "./en-US/user";

export default {
  ...user,
};
